module.exports = __webpack_public_path__ + "static/media/a3.7aac0615.png";